import { css, useTheme } from "@emotion/react";
import { omit } from "lodash/fp";

import {
  Card,
  CardContent,
  CardTitle,
  CardMeta,
  Time,
  Button,
  useThemeProps,
  Excerpt,
  handleComponentsProp,
  parseStyle,
  Icon,
} from "../../../wsui/base";

const DefaultExcerpt = Excerpt;
const DefaultButton = Button;

export default function DefaultPostCard(props) {
  // eslint-disable-next-line no-unused-vars
  const theme = useTheme();
  props = useThemeProps({ props, name: "DefaultPostCard" });
  props = useThemeProps({ props, name: "PostCard" });
  let {
    as: Component = Card,
    post,
    components = {},
    dateFormat = {
      year: "numeric",
      month: "long",
      day: "numeric",
    },
    style,
    buttonMarginTop = 5,
    titleProps = { variant: "h4" },
    metaProps = {},
    // visibleFields,
    isFieldVisible,
    iconSize = 20,
    ctaVariant,
    excerptLines,
    align,
    ...restProps
  } = omit(["visibleFields"], props);
  const contentAlign =
    align === "left" || align === "center" || align === "right"
      ? align
      : undefined;
  const contentJustify =
    contentAlign === "right"
      ? "end"
      : contentAlign === "center"
        ? "center"
        : "start";
  titleProps = {
    ...titleProps,
    align: titleProps.align ?? contentAlign,
  };
  metaProps = {
    ...metaProps,
    justifyContent: metaProps.justifyContent ?? contentJustify,
  };

  let { title, image, link, date, description, cta, icon } = post;

  let { Button, Excerpt, Title, Meta } = handleComponentsProp(components, {
    Button: DefaultButton,
    Excerpt: DefaultExcerpt,
    Title: CardTitle,
    Meta: CardMeta,
  });

  return (
    <Component
      title={isFieldVisible("title") ? title : null}
      link={link}
      image={isFieldVisible("image") ? image : null}
      css={css`
        ${parseStyle(style, theme)}
      `}
      {...restProps}
    >
      <CardContent
        css={css`
          text-align: ${contentAlign || "start"};
          justify-items: ${contentJustify};
        `}
      >
        {isFieldVisible("icon") && (
          <div>
            <Icon name={icon} size={iconSize} />
          </div>
        )}
        <Title {...titleProps} />
        {isFieldVisible("date") && (
          <Meta {...metaProps}>
            <Time date={date} format={dateFormat} />
          </Meta>
        )}
        {isFieldVisible("description") ? (
          <Excerpt variant="description" lines={excerptLines} align={contentAlign}>
            {description}
          </Excerpt>
        ) : null}
        {cta ? (
          <Button
            css={css`
              justify-self: ${contentJustify};
              margin-block-start: ${theme.getLength(buttonMarginTop)};
            `}
            variant={ctaVariant}
            {...cta}
          />
        ) : null}
      </CardContent>
    </Component>
  );
}
